module.exports = ScreenShare;


//////////////////
// WEBPACK FOOTER
// external "ScreenShare"
// module id = nRbF
// module chunks = 1